// Cliente Supabase único de la app. Usa el ANON_KEY (público): el aislamiento
// multi-tenant lo garantizan RLS + el JWT firmado por Supabase Auth, no el secreto
// de la llave. El schema por defecto es 'app' (donde viven tablas y RPC).
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./database.types";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "Faltan VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copia .env.example a .env.local.",
  );
}

export const supabase = createClient<Database>(url, anonKey, {
  db: { schema: "app" },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // En la app nativa (Tauri) y PWA queremos sesión persistente local.
    storageKey: "ferresaas.auth",
  },
});

/** Lee organization_id/role del JWT vigente (app_metadata, no falsificable). */
export async function currentTenant(): Promise<{ orgId: string | null; role: string | null }> {
  const { data } = await supabase.auth.getSession();
  const meta = (data.session?.user.app_metadata ?? {}) as {
    organization_id?: string;
    role?: string;
  };
  return { orgId: meta.organization_id ?? null, role: meta.role ?? null };
}
